import { PopupBase, PopupType } from '../popup';

export class ConfirmationPopupModel implements PopupBase {
    public type = PopupType.Confirmation;

    constructor(
        public id: string,
        public title: string,
        public content: string,
        public onConfirm: () => void,
        public onCancel: () => void = () => {},
    ) {}
}
